<div class="flex relative items-stretch flex-col flex-1">
	<div
		*ngIf="controller.showCoachingPlan$ | async"
		class="top-0 left-0 w-full h-full flex absolute items-stretch flex-col"
	>
		<spr-block-title
			*ngIf="controller.coacheeName$ | async; let coacheeName"
			[first]="true"
			[showBack]="true"
			(goBack)="onUserPlanGoBack()"
			contentClass="flex items-center"
		>
			<a
				[routerLink]="controller.coacheeProfileRoute$ | async"
				class="text-xl font-medium"
			>
				{{ coacheeName }}
			</a>
		</spr-block-title>
		<spr-coaching-plan
			[bdcWalkTriggerFor]="coachingPlanWalkthrough"
			[enabled]="appService.canShowProductTour$ | async"
			class="flex-auto"
		></spr-coaching-plan>
		<bdc-walk-popup
			#coachingPlanWalkthrough
			[buttonText]="'presentation.common.bdcWalkthrough.ok' | translate"
			[header]="controller.i18n + '.coachingPlanWalkthrough.header' | translate"
			[horizontal]="true"
			[showButton]="true"
			[showCloseButton]="false"
			name="coachingPlanWalkthrough"
		>
			<span class="whitespace-pre-line">
				{{ controller.i18n + '.coachingPlanWalkthrough.text' | translate }}
			</span>
		</bdc-walk-popup>
	</div>
	<div
		*ngIf="controller.showCoacheesList$ | async"
		class="top-0 left-0 w-full h-full flex absolute items-stretch flex-col"
	>
		<spr-block-title [first]="true">
			<div class="flex align-center">
				<span class="flex-1">
					{{ 'presentation.app.sidebar.coachees.title' | translate }}
				</span>
				<button
					[title]="'presentation.app.sidebar.coachees.add.title' | translate"
					(click)="showAddCoachee = true"
					class="p-button-primary-transparent"
					icon="fas fa-user-plus"
					pButton
					type="button"
				></button>
				<p-dialog
					[dismissableMask]="true"
					[header]="
						'presentation.app.sidebar.coachees.addCoachee.header' | translate
					"
					[modal]="true"
					[resizable]="false"
					[style]="{ maxWidth: '80vw', width: '450px' }"
					[(visible)]="showAddCoachee"
					appendTo="body"
				>
					<p-tabView
						class="flex-auto h-full overflow-hidden"
						styleClass="p-0 space-y-3"
					>
						<p-tabPanel
							[header]="
								'presentation.app.sidebar.coachees.addCoachee.newCoachee.header'
									| translate
							"
						>
							<spr-sidebar-add-coachee
								*ngIf="showAddCoachee"
								(addClick)="onCreateCoacheeClick($event)"
							></spr-sidebar-add-coachee>
						</p-tabPanel>
						<p-tabPanel
							*ngIf="controller.hasCoacheesWithoutCoach$ | async"
							[header]="
								'presentation.app.sidebar.coachees.addCoachee.existingCoachee.header'
									| translate
							"
						>
							<spr-sidebar-add-existing-coachee
								*ngIf="showAddCoachee"
								(addClick)="onAddExistingCoacheeClick($event)"
							></spr-sidebar-add-existing-coachee>
						</p-tabPanel>
					</p-tabView>
				</p-dialog>
			</div>
		</spr-block-title>
		<spr-sidebar-coachees
			[chatUserId]="controller.appChatUserId$ | async"
			(openChat)="onCoacheeOpenChat($event)"
			(openPlan)="onCoacheeOpenPlan($event)"
		></spr-sidebar-coachees>
	</div>
</div>
<div
	*ngIf="controller.notifications$ | async | nullIfEmpty; let notifications"
	class="flex relative items-stretch flex-col flex-none"
>
	<spr-block-title
		[backIcon]="controller.notificationsIcon$ | async"
		[showBack]="true"
		(goBack)="toggleNotifications()"
	>
		<div class="flex flex-wrap align-center">
			<div class="flex-1">
				<span
					[badgeBackgroundColor]="'p-background-color-secondary'"
					[sprBadge]="
						(controller.isNotificationsExpanded$ | async) ? '' : notifications?.length
					"
				>
					{{ 'presentation.app.sidebar.notifications.title' | translate }}
				</span>
			</div>
			<button
				*ngIf="controller.showCloseAllButton$ | async"
				[title]="'presentation.app.sidebar.notifications.close.title' | translate"
				(click)="onCloseAllClick()"
				class="p-button-primary-transparent"
				icon="far fa-times-circle"
				pButton
				type="button"
			></button>
		</div>
	</spr-block-title>
	<div
		*ngIf="controller.isNotificationsExpanded$ | async"
		class="flex-auto relative min-h-screen-40"
	>
		<ng-scrollbar
			class="absolute w-full h-full top-0 left-0"
			track="vertical"
			visibility="hover"
		>
			<div class="p-3 space-y-3">
				<spr-sidebar-notification
					*ngFor="
						let notification of notifications;
						trackBy: trackByNotification;
						let isLast = last
					"
					[class.last]="isLast"
					[locale]="controller.locale$ | async"
					[notification]="notification"
				></spr-sidebar-notification>
			</div>
		</ng-scrollbar>
	</div>
</div>
<button
	*ngIf="showToggleButton"
	(click)="onCollapseClick()"
	class="top-5 w-10 h-10 -right-10 absolute rounded-l-none"
	icon="fas fa-bars"
	pButton
></button>
